import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const renderTitle = (title) => {
  if (title) {
    return <title>{title}</title>;
  }

  return null;
};

const Icon = ({ name, className, title, ...other }) => (
  <svg className={classNames('icon', className)} {...other}>
    {renderTitle(title)}
    <use xlinkHref={`#${name}`} />
  </svg>
);

Icon.defaultProps = {
  className: '',
  title: '',
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js